import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { HistorialDCambios } from 'src/app/clientes/models/historialDeCambios';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import swal from 'sweetalert2';
import { ProyectosService } from '../../proyectos.service';
import { UtileriasService } from 'src/app/utilerias/service/utilerias.service';
import { AuthService } from 'src/app/security/auth.service';
import { Empleado } from 'src/app/shared/model/empleado/empleado.model';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-historial-de-cambios',
  standalone: true,
  templateUrl: './historial-de-cambios.component.html',
  styleUrls: ['./historial-de-cambios.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    // Terceros
    NgxMatSelectSearchModule,
  ],
})
export class HistorialDeCambiosComponent {
  historialCambios: FormGroup;
  objetoHistorial: HistorialDCambios = new HistorialDCambios();
  formCliente = new FormControl();
  empleadoAutoriza: number = null;
  listaDEmpleados: Array<Empleado>;

  constructor(
    public dialogRef: MatDialogRef<HistorialDeCambiosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formbuilder: FormBuilder,
    private proyectosService: ProyectosService,
    private utilerias: UtileriasService,
    private authS: AuthService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.historialCambios = this.formbuilder.group({
      version: ['', Validators.required],
      autortiza: ['', Validators.required],
      descripcion: [''],
      tipo_cambio: [''],
    });
    this.formCliente.valueChanges.subscribe(() => {
      this.filtraCliente();
    });
    this.consultaEmpleados();
  }

  // 🔑 Abrir este diálogo con backdropClass aplicado
  static abrirDialog(dialog: MatDialog, data: any) {
    return dialog.open(HistorialDeCambiosComponent, {
      width: '600px',
      panelClass: 'custom-dialog-container',
      backdropClass: 'custom-dialog-backdrop', // 👈 para el fondo oscuro
      data,
    });
  }

  onClienteSelectionChange(event: MatSelectChange) {
    const valorseleccionado = event.value;

    if (valorseleccionado !== null) {
      const empleadoSeleccionado = this.listaDEmpleados.find(
        cliente => cliente.idEmpleado === valorseleccionado
      );

      if (empleadoSeleccionado) {
        this.objetoHistorial.autoriza =
          empleadoSeleccionado.persona.nombreCompleto;
      }
    }
  }

  save(): void {
    this.objetoHistorial.tipo_cambio = this.data.tipo_cambio;
    this.objetoHistorial.id_tipo = this.data.id ? this.data.id : 0;
    this.proyectosService.incrementarVersion(this.objetoHistorial.id_tipo);

    const versionActual =
      this.proyectosService.versionesPorTipo.get(this.objetoHistorial.id_tipo) ||
      '1.0';

    this.objetoHistorial.version = versionActual;
    this.proyectosService.guardarHistorialCambio(this.objetoHistorial).subscribe(response => {
      this.dialogRef.close(true);
      swal
        .fire({
          title: response.pCodRetorno === '00000' ? 'ÉXITO' : 'ERROR',
          text: response.pMensaje,
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          confirmButtonText: 'Aceptar',
          icon: response.pCodRetorno === '00000' ? 'success' : 'warning',
        })
        .then(ress => {
          if (
            Constantes.DIEZ ===
            this.utilerias.convertirANumero(response.pCodRetorno)
          ) {
            this.authS.logout();
          }
        });
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  clearNombreCli() {
    this.empleadoAutoriza = null;
    this.formCliente.setValue('');
    this.consultaEmpleados();
  }

  consultaEmpleados() {
    this.proyectosService.consultaEmpleados().subscribe(res => {
      this.listaDEmpleados = res.list;
    });
  }

  filtraCliente() {
    let search = this.formCliente.value;
    if (!search && this.listaDEmpleados) {
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listaDEmpleados = this.listaDEmpleados.filter(cliente =>
      cliente.persona.nombreCompleto.toLowerCase().includes(search)
    );
  }
}
